import type { WabaTemplate } from "@school-sales-ai/shared";

/**
 * The confirmation for the one action here that cannot be undone.
 *
 * The 30-day name lock is the whole reason this dialog exists and the reason the
 * action is super-admin only: "quitar de mi lista" is archiving, and a school
 * admin reaching for that should never land on something that costs them the
 * name for a month.
 */
export function DeleteInMetaDialog({
  template,
  onCancel,
  onConfirm,
  pending,
}: {
  template: WabaTemplate;
  onCancel: () => void;
  onConfirm: () => void;
  pending: boolean;
}): React.JSX.Element {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-ink-900/40 p-4">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
        <h2 className="text-lg font-semibold text-ink-900">Eliminar en Meta</h2>
        <p className="mt-2 text-sm text-ink-700">
          Se eliminará <strong>{template.name}</strong> ({template.language}) de la
          cuenta de WhatsApp del cliente.
        </p>
        <p className="mt-3 rounded-md bg-amber-50 p-3 text-sm text-amber-900">
          Meta reserva el nombre <strong>30 días</strong> después de eliminar una
          plantilla aprobada: no se podrá volver a crear una con este nombre hasta
          entonces. Si sólo quieres que deje de aparecer, archívala.
        </p>
        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-md border border-ink-200 px-4 py-2 text-sm text-ink-700"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={pending}
            className="rounded-md bg-red-700 px-4 py-2 text-sm text-white disabled:opacity-50"
          >
            {pending ? "Eliminando…" : "Eliminar en Meta"}
          </button>
        </div>
      </div>
    </div>
  );
}
